module.exports = __webpack_public_path__ + "img/app2.fe77e5ac.jpg";